// "Arbeitsbereich"-Gruppe der Settings-Navigation: Spaces, Projekt-Templates.
// Ausgelagert aus routes/Settings.tsx (Redesign: 15 Abschnitte in Tabs
// gruppiert) nur um die Hauptdatei unter der 500-Zeilen-Grenze zu halten —
// wortgleiche Verschiebung, keine Props (beide Sektionen sind autark).

import { SpacesSection } from "../../components/SpacesSection";
import { TemplatesSection } from "../../components/TemplatesSection";

export function WorkspaceGroup(): preact.JSX.Element {
  return (
    <div class="flex flex-col gap-8">
      {/* Spaces management — available to all internal users. */}
      <section>
        <h2 class="text-sm font-semibold uppercase tracking-wider text-[color:var(--color-on-surface-variant)] mb-3">
          Spaces
        </h2>
        <p class="text-xs text-[color:var(--color-on-surface-variant)] mb-3">
          Spaces gruppieren deine Projekte in der Sidebar. Du kannst neue Spaces anlegen,
          bestehende umbenennen, einfärben und Mitglieder verwalten.
        </p>
        <SpacesSection />
      </section>

      {/* Templates management */}
      <section>
        <h2 class="text-sm font-semibold uppercase tracking-wider text-[color:var(--color-on-surface-variant)] mb-3">
          Projekt-Templates
        </h2>
        <p class="text-xs text-[color:var(--color-on-surface-variant)] mb-3">
          Templates ermöglichen das schnelle Anlegen neuer Projekte mit vorgefertigten
          Phasen und Aufgaben. Öffne ein Projekt und wähle „Als Template speichern".
        </p>
        <TemplatesSection />
      </section>
    </div>
  );
}
